import fetch from 'lib/fetch'

export const REQUEST_API_USAGE = 'REQUEST_API_USAGE'
export const REQUEST_API_USAGE_ERROR = 'REQUEST_API_USAGE_ERROR'
export const RECEIVE_API_USAGE = 'RECEIVE_API_USAGE'

export function fetchAPIUsage (workspaceSlug) {
  return {
    types: {
      request: REQUEST_API_USAGE,
      failure: REQUEST_API_USAGE_ERROR,
      receive: RECEIVE_API_USAGE
    },
    payload: { workspaceSlug },
    callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/billing/legacy-usage`).then(res => {
      if (!res.ok) {
        const err = new Error('Unable to fetch usage')
        err.status = res.status
        throw err
      }
      return res.json()
    })
  }
}



// WEBPACK FOOTER //
// ./actions/legacy-api-usage.js